requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },

        load ( link , element , optionId , variant ){

            if( optionId )
                variant ??= document.getElementById
                    (`current-variant-${ optionId }`)?.innerText

            const url = new URL(link,location.href)

            if( variant )
                url.searchParams.set('variant',variant)

            const key = url.href

            this.buttonQuickView ||= element

            console.debug(`QuickView::Load`,{ variant , url , optionId })

            if( this.cachedResults[ key ] ){

                const content = document.querySelector
                    (`#quickview-product-content`)

                const html = this.cachedResults[ key ]

                content.setHTMLUnsafe(html)
                content.parentElement.scrollTop = 0

                return true
            }

            if( this.cachedfetch[ key ] )
                return true

            this.cachedfetch[ key ] = true
            this.loading = true

            fetch(url)
            .then(( response ) => response.text() )
            .then(( html ) => {

                const parser = new DOMParser

                const dom = parser.parseFromString
                    (html,'text/html')

                return dom
            })
            .then(( dom ) => {

                const productInfo = dom.querySelector
                    (`.x-section.section-product-info`)

                if( productInfo ){

                    // Alle Sections des Produkt-Templates ( inkl. A+ Content )
                    // in PDP-Reihenfolge, außer Cross-Selling Sections

                    const excluded = [
                        'section-featured-collection' ,
                        'section-product-recommendations' ,
                        'section-recently-viewed'
                    ]

                    const sections = dom.querySelectorAll
                        (`.x-section[ id^='shopify-section-template--' ]`)

                    let html = ''

                    for ( const section of sections )
                        if( ! excluded.some(( name ) => section.classList.contains(name) ) )
                            html += section.outerHTML

                    const content = document.querySelector
                        (`#quickview-product-content`)

                    content.setHTMLUnsafe(html)
                    content.parentElement.scrollTop = 0

                    this.cachedResults[ key ] = html

                } else {

                    const meta = dom.querySelector
                        (`meta[ http-equiv = 'refresh' ]`)

                    if( ! meta )
                        return

                    const content = meta.getAttribute('content') ?? ''

                    const match = content.match(/url=(.+)/i)

                    if( ! match )
                        return

                    const redirect = match[1].trim()

                    if( ! redirect )
                        return

                    if( redirect !== url.href )
                        this.load(redirect)
                }
            })
            .catch(( exception ) => {
                console.error(`QuickView::Load::Exception`,exception)
            })
            .finally(() => {
                this.loading = false
                this.cachedfetch[ key ] = false
            })

            return true
        },

      open(isMiniCart = false) {
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        this.buttonQuickView = '';
        if(!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
      },
      focusQuickView(quickView, btnClose) {
        if ( !this.selected ) {
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },
      removeFocusQuickView() {
        if ( !this.selected ) {
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
      closePopupMobile() {
        this.openPopupMobile = false;
      },
      showChooseOption() {
        this.openPopupMobile = true;
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          Alpine.store('xPopup').close();
        }
      },
      clickInsideContentQuickView(evt) {
        const link = evt.target.closest('.Product-Variations-Product');
        if (link) {
          evt.preventDefault();
          this.load(link.getAttribute('href'));
        }
        evt.stopPropagation();
      }
    });
  });
});
